/**
 * KpiStrip — 4–6 KPI cells in one bordered card. Port of `V3KpiStrip`
 * from regional-chrome.jsx.
 *
 * Each cell renders eyebrow / big tabular number / delta + sub.
 */
export interface KpiCell {
  label: string;
  value: string;
  delta?: string;
  /** `true` good, `false` bad, `null|undefined` neutral. */
  good?: boolean | null;
  sub?: string;
  /** Optional inline color override for the value (e.g. accent on Hero KPI). */
  accent?: string;
}

export interface KpiStripProps {
  items: KpiCell[];
}

function deltaClass(good?: boolean | null): string {
  if (good === true) return 'nb-kpi-delta good';
  if (good === false) return 'nb-kpi-delta bad';
  return 'nb-kpi-delta';
}

function deltaArrow(good?: boolean | null): string {
  if (good === true) return '↑ ';
  if (good === false) return '↓ ';
  return '';
}

export function KpiStrip({ items }: KpiStripProps) {
  if (!items.length) return null;
  return (
    <div className="nb-kpi-strip" style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}>
      {items.map((k) => (
        <div key={k.label} className="nb-kpi-cell">
          <div className="nb-eyebrow" style={{ fontSize: 10 }}>
            {k.label}
          </div>
          <div
            className="nb-tabular"
            style={{
              fontSize: 26,
              fontWeight: 700,
              letterSpacing: '-0.02em',
              lineHeight: 1.15,
              marginTop: 4,
              color: k.accent,
            }}
          >
            {k.value}
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginTop: 3 }}>
            {k.delta && (
              <span className={deltaClass(k.good)} style={{ fontSize: 11 }}>
                {deltaArrow(k.good)}
                {k.delta}
              </span>
            )}
            {k.sub && <span style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>{k.sub}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}
